import { useChangeLocale } from "@/hooks/useChangeLocale";
import {
  Button,
  HStack,
  Menu,
  MenuButton,
  MenuButtonProps,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { useRouter } from "next/router";
import { FlagEmoji } from "react-international-phone";
const sizes = {
  sm: {
    flagSize: 16,
    chevronSize: 8,
    selectedFlagSize: 24,
  },
  md: {
    flagSize: 24,
    chevronSize: 12,
    selectedFlagSize: 32,
  },
};

export const LanguageToggle = ({
  size = "md",
  showLabel = false,
  ...props
}: Omit<MenuButtonProps, "size" | "children"> & {
  size?: keyof typeof sizes;
  showLabel?: boolean;
}) => {
  const { locale } = useRouter();
  const changeLocale = useChangeLocale();

  return (
    <Menu>
      <MenuButton
        as={Button}
        variant="unstyled"
        rounded="full"
        color="white"
        bgColor="transaprent"
        aria-label="Change language"
        _hover={{ color: "brand.1000" }}
        {...props}
      >
        <HStack w="full" fontWeight={500}>
          <Text>{locale === "en" ? "ENG" : "POR"}</Text>
        </HStack>
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => changeLocale("en")}>
          <HStack>
            <FlagEmoji iso2={"us"} size={sizes[size].flagSize} />{" "}
            <Text>English</Text>
          </HStack>
        </MenuItem>
        <MenuItem onClick={() => changeLocale("pt")}>
          <HStack>
            <FlagEmoji iso2={"pt"} size={sizes[size].flagSize} />
            <Text>Portugues</Text>
          </HStack>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
